// Global
export const GET_NAVIGATION_CONTENTS = 'GET_NAVIGATION_CONTENTS';
export const SET_NAVIGATION_MENU_BACKGROUND = 'SET_NAVIGATION_MENU_BACKGROUND';
export const SET_NAVIGATION_PAGINATION = 'SET_NAVIGATION_PAGINATION';
export const SET_NAVIGATION_MENU_HIDDEN = 'SET_NAVIGATION_MENU_HIDDEN';
export const GET_PAGE_TITLE = 'GET_PAGE_TITLE';
export const SET_IS_TRANSPORTED = 'SET_IS_TRANSPORTED';
export const SET_HOMEPAGE_HEADER_OFFSET = 'SET_HOMEPAGE_HEADER_OFFSET';
export const SET_CATEGORY_FILTER = 'SET_CATEGORY_FILTER';
export const SET_HOMEPAGE_POSTERS_QUERY_VARS = 'SET_HOMEPAGE_POSTERS_QUERY_VARS';

// Cards
export const GET_ARTICLE_CARDS = 'GET_ARTICLE_CARDS';
export const GET_HOMEPAGE_POSTERS = 'GET_HOMEPAGE_POSTERS';
export const SET_ARTICLE_CARDS_LOADED = 'SET_ARTICLE_CARDS_LOADED';
export const SET_ARTICLE_CATEGORY = 'SET_ARTICLE_CATEGORY';
export const SET_ARTICLE_POSTDATE = 'SET_ARTICLE_POSTDATE';
export const SET_PREVIOUS_ARTICLE_FOCUS = 'SET_PREVIOUS_ARTICLE_FOCUS';
